<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <td class="text-xs-center">
          <v-btn color="blue" @click="downloadBilletsList()" dark>
            <v-icon v-if="billetsBankBatch"> download </v-icon>
            <span>Baixar Lista de Faturamento</span>
          </v-btn>
        </td>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="billetsBankBatch"
        :search="search"
        :pagination.sync="pag"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.bar_code }}</td>
          <td class="text-xs-center">
            {{ props.item.total_invoice | formatCurrency }}
          </td>
          <td class="text-xs-center">{{ props.item.bill_id }}</td>
          <td class="text-xs-center">{{ props.item.billing_id }}</td>
          <td class="text-xs-center">{{ props.item.competence }}</td>
          <td class="text-xs-center">
            {{ props.item.due_date_utility | formatarDate }}
          </td>
          <td>
            <v-chip
              :color="
                props.item.utility_payment_status | billingBatchStatusColor
              "
              text-color="white"
            >
              {{ props.item.utility_payment_status | billingBatchStatus }}
            </v-chip>
            <v-chip
              v-if="props.item.status === 'payment_error'"
              color="error"
              text-color="white"
            >
              <v-icon slot="start" small>alert</v-icon
              >{{ props.item.error | billingBatchError }}
            </v-chip>
          </td>
          <td>
            <v-btn
              v-if="
                props.item.status !== 'batch_accepted' &&
                props.item.status !== 'payment_completed' &&
                props.item.utility_payment_status !== 'paid_manually'
              "
              color="success"
              fab
              small
              class="v-btn--round"
              @click="openDialog(props.item.billing_id, props.item.id)"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </td>
        </template>

        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Sua busca por "{{ search }}" Não encontrou resultados.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
    <v-dialog v-model="pg_manual.dialog" max-width="600">
      <v-card>
        <v-card-title class="headline red lighten-2 white--text">
          <v-icon color="white darken-2 pr-2" large
            >mdi-alert-circle-outline</v-icon
          >
          <span class="ml-2">Marcar como pago manualmente</span>
        </v-card-title>
        <v-card-text>
          Tem certeza de que deseja realizar esta ação?
        </v-card-text>
        <v-card-text>
          <b>Obs: Esta ação NÃO pode ser desfeita.</b>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" @click="closeDialog">Cancelar</v-btn>
          <v-btn color="green" @click="confirmAction">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import XLSX from "xlsx";
import { payManually } from "../../services/paid_manually";

export default {
  props: ["batch_id", "search_text"],
  data() {
    return {
      search: "",
      color: "",
      snackMessage: "",
      snackbar: false,
      headers: [
        {
          text: "Código de Barras",
          align: "center",
          value: "bar_code",
        },
        {
          text: "Valor",
          align: "center",
          value: "total_invoice",
        },
        {
          text: "Nome",
          align: "center",
          value: "bill_id",
        },
        {
          text: "Id",
          align: "center",
          value: "billing_id",
        },
        {
          text: "Competência",
          align: "center",
          value: "competence",
        },
        {
          text: "Data de Venc.",
          align: "center",
          value: "due_date_utility",
        },
        {
          text: "Status",
          align: "center",
          value: "utility_payment_status" || "status",
        },
        {
          text: "Pg Manual",
          align: "center",
        },
      ],

      pg_manual: {
        dialog: false,
      },

      pag: {
        rowsPerPage: 100,
      },
      selectedBillingId: null,
      selectedBilletId: null,
    };
  },

  mounted() {
    if (!this.billetsBankBatch || this.billetsBankBatch.length <= 0) {
      this.getBilletsBankBatch(this.batch_id);
      this.search = this.search_text;
    }
  },

  computed: {
    ...mapState("uniquebilling", ["billetsBankBatch", "getBillings"]),
    ...mapState(["user"]),
  },
  watch: {
    batch_id() {
      this.getBilletsBankBatch(this.batch_id);
    },
    search_text() {
      this.search = this.search_text;
    },
  },

  methods: {
    ...mapActions("uniquebilling", [
      "getBilletsBankBatch",
      "getBankBatchType",
      "updateEmail",
    ]),

    showSnackBar(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    downloadBilletsList() {
      try {
        const billetsListCsv = [
          ["Código de Barras", "Nome da Conta", "Id da Conta", "Competência"],
          ...this.billetsBankBatch.map((bill) => [
            bill.bar_code,
            bill.bill_id,
            bill.billing_id,
            bill.competence,
          ]),
          // Descomentar as duas linhas abaixo caso precisar do download CSV
          // .map(e => e.join(', '))
          // .join('\n')
        ];

        // Download EXCEL
        const ws = XLSX.utils.aoa_to_sheet(billetsListCsv);
        const wb = XLSX.utils.book_new();
        const file = "Lote-" + this.batch_id;
        XLSX.utils.book_append_sheet(wb, ws, file);
        XLSX.writeFile(wb, file + ".xlsx");

        // Download CSV
        // const blob = new Blob(billetsListCsv, {type: 'text/csv'})
        // const url = window.URL.createObjectURL(blob)
        // const link = document.createElement('a')
        // link.href = url
        // link.download = 'Lote-' + this.batch_id
        // link.click()
      } catch (err) {
        this.showSnackBar(
          "Não foi possível fazer o download da lista de faturamentos." +
            err.message,
          "red",
        );
      }
    },

    openDialog(billingId, billetId) {
      this.pg_manual.dialog = true;
      this.selectedBillingId = billingId;
      this.selectedBilletId = billetId;
    },

    closeDialog() {
      this.pg_manual.dialog = false;
    },

    async confirmAction() {
      const type = await this.getBankBatchType(this.batch_id);
      const billing_id = this.selectedBillingId;
      const billet_id = this.selectedBilletId;
      const pay_manually = await payManually("paidManually", billing_id, type);
      if (pay_manually.data.message !== "pago manualmente") {
        if (pay_manually.data.error) {
          this.showSnackBar(`${pay_manually.data.error}`, "red");
          return;
        }
        this.showSnackBar(pay_manually.data.message, "red");
      } else {
        try {
          const data = {
            user_email: this.user.email,
            batch_id: this.batch_id,
            billet_id: billet_id,
          };
          await this.updateEmail(data);
          this.showSnackBar(`${pay_manually.data.message}`, "green");
        } catch (error) {
          this.showSnackBar("Erro ao marcar como pago manualmente.", "red");
          return;
        }
      }
      this.pg_manual.dialog = false;
    },

    filters: {
      formatCurrency(value) {
        if (typeof value !== "number") {
          return value;
        }
        const formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });
        return formatter.format(value);
      },
    },
  },
};
</script>
